import { createAsyncThunk } from "@reduxjs/toolkit"
import axiosAPI from "../../api/axiosAPI"

export const login = createAsyncThunk("login", async (data) => {
    try {
        const response = await axiosAPI.post("/login", data);
        return response
    } catch (err) {
        return err
    }
})

export const getProfile = createAsyncThunk("profile", async () => {
    try {
        const response = await axiosAPI.get("/get-profile");
        return response
    } catch (err) {
        return err
    }
})

export const updateEmployee = createAsyncThunk("updateEmployee", async (data) => {
    try {
        const { id, values } = data;
        const { address, dateOfBirth, departmentId, designationId, email, gender, joiningData, name, number, permissions, reportsTo } = values
        const response = await axiosAPI.put(`/update-user/${id}`, { address, dateOfBirth, departmentId, designationId, email, gender, joiningData, name, number, permissions, reportsTo });
        return response
    } catch (err) {
        return err
    }
})

export const changePassword = createAsyncThunk("changePassword", async (data) => {
    try {
        const response = await axiosAPI.put("/change-password", data);
        return response
    } catch (err) {
        return err
    }
});

export const updateProfile = createAsyncThunk("updateProfile", async (data) => {
    try {
        const response = await axiosAPI.put("/update-profile", data);
        return response
    } catch (err) {
        return err
    }
});

export const logout = createAsyncThunk("logout", async (data) => {
    try {
        const response = await axiosAPI.post("/logout");
        return response
    } catch (err) {
        return err
    }
})

export const checkSession = createAsyncThunk("checkSession", async () => {
    try {
        const response = await axiosAPI.get("/check-session");
        return response
    } catch (err) {
        return err
    }
})